module.exports = __webpack_public_path__ + "60bd9a4df8cf99c3c49c102d8fe69fab.svg";